import { render } from "./MyAnswers.vue?vue&type=template&id=81de8882&scoped=true"
import script from "./MyAnswers.vue?vue&type=script&lang=js"
export * from "./MyAnswers.vue?vue&type=script&lang=js"

import "./MyAnswers.vue?vue&type=style&index=0&id=81de8882&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81de8882"]])

export default __exports__